import React, { createRef } from "react";
import {
    DatePicker,
    Button,
    Space,
    Row,
    Col,
    Checkbox,
    Select,
    Modal,
    Image,
    Tooltip,
    Dropdown
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import DriverExpenseReportStore from "../store/DriverExpenseReportStore.js";
import CompanyAutocomplete from "./CompanyAutocomplete";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import DriverLoginReportStore from "../store/DriverLoginReportStore.js";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import PythonMessageAlert from "./PythonMessageAlert";
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
const { Option } = Select;
class DriverExpenseReport extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        // this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.handleTableChange = this.handleTableChange.bind(this);
        this.driverExpenseReportStore = new DriverExpenseReportStore();
        this.driverLoginReportStore = new DriverLoginReportStore();
        this.pythonMessageRef = createRef();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            company_name: "",
            listUpdated: 0,
            companyId: null,
            selectedDriver: [],
            selectAllDrivers: false,
            date: "",
            time: "",
            fromDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            modalVisible: false,
            column: "",
            filter: "",
            showMonthPopup: false,
            Notcompany: false,
            pythonReportMessage: false,
            reportmessage: "",
            selectedColumns: [
                {
                    // title: "User Name",
                    title: context.translate("_DRIVER_"),
                    dataIndex: "driverName",
                    key: "driverName",
                    width: "15%",
                },
                {
                    // title: "Password",
                    title: context.translate("_EXPANSE_TYPE_"),
                    dataIndex: "expanceType",
                    key: "expanceType",
                    width: "15%",
                },
                {
                    // title: "Login DateTime",
                    title: context.translate("_DATE_"),
                    dataIndex: "date",
                    key: "date",
                    width: "15%",
                    render: (value) => {
                        if (value) {
                            const formattedDateTime = dayjs(value).format(
                                "DD-MM-YYYY"
                            );
                            return <>{formattedDateTime}</>;
                        } else {
                            <></>
                        }

                    },
                },
                {
                    // title: "Login IP ",
                    title: context.translate("_TOTAL_AMMOUNT_"),
                    dataIndex: "totalAmount",
                    key: "totalAmount",
                    width: "15%",
                }

            ],
        }

        this.ExportMenuProps = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={Excel}
                            ></Image>
                            {context.translate("_EXPORT_AS_EXCEL_")}
                        </div>
                    ),
                    key: "excel",
                },
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={PDF}
                            ></Image>
                            {context.translate("_EXPORT_AS_PDF_")}
                        </div>
                    ),
                    key: "pdf",
                },
            ],
            onClick: async (val) => {
                let result = [];
                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));


                    var getData = {
                        companyId: this.state.companyId,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        driverId: this.state.selectedDriver,
                        colList: result.toString(),
                    };
                    if (val.key === "excel") {
                        await this.driverExpenseReportStore.exportExcel(getData);

                        const isSuccess =
                            this.driverExpenseReportStore?.pythonReportMessage === true;
                        const isError = this.driverExpenseReportStore?.pythonReportErrorMessage;

                        if (isSuccess || isError) {
                            await this.setState({
                                reportmessage: isSuccess ? "success" : "error",
                            });
                            await this.triggerReport();
                        }


                    }
                    if (val.key === "pdf") {
                        await this.driverExpenseReportStore.exportpdf(getData);
                        const isSuccess =
                            this.driverExpenseReportStore?.pythonReportMessage === true;
                        const isError = this.driverExpenseReportStore?.pythonReportErrorMessage;
                        console.log("first", isSuccess)
                        if (isSuccess || isError) {
                            await this.setState({
                                reportmessage: isSuccess ? "success" : "error",
                            });
                            await this.triggerReport();
                        }
                    }
                }
            }
        };
        this.newColumns = [...this.state.selectedColumns];
    }

    async componentDidMount() {
        this.setState({ pageSize: 50 });
        await this.setState({ column: this.state.selectedColumns });

        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }

        await this.setState({ listUpdated: 1 });

        // await this.setState({ listUpdated: 1 });
    }
    handleSelectAllDrivers = async (e) => {
        if (this.state.selectAllDrivers) {
            const allDrivers = this.driverLoginReportStore?.getDrivers.map((val) => {
                return val.driverId;
            });
            await this.setState({ selectedDriver: allDrivers });
        } else {
            await this.setState({ selectedDriver: [] });
        }
    };


    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.showData();
    }

    async handleChange(comp) {
        await this.setState({ companyId: comp?.value, Notcompany: false, });
        await this.setState({ selectedDriver: [], selectAllDrivers: false, currentPage: 1, });
        await this.driverLoginReportStore.getDriversByCompanyId({
            companyId: comp.value,
        });

        await this.setState({ listUpdated: 1 });
    }

    showData = async () => {
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (this.state.companyId) {
            this.setState({ Notcompany: false });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.driverExpenseReportStore.loadData({
                    offset: (this.state.currentPage - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                    driverId: this.state.selectedDriver,
                });
                await this.setState({ listUpdated: 1 });
            }
        }
    };
    addMonths = (date, months) => {
        var indx = dayjs().month() + -6;
        return dayjs().month(indx);
    };

    checkFromDate(dates) {
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {
            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0]?.format(format),
                toDate: dates[1]?.format(format),
            });
        }
    };
    handleCheckboxChange = async (column) => {
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );

            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
            // await  this.updateVisibleColumns();
        }
    };

    updateVisibleColumns = () => {
        this.setState({ column: this.state.selectedColumns });
    };

    refreshList = async () => {
        await this.setState({ loading: false, current: 1, currentPage: 1 });
        await this.showData();
    };
    triggerReport = () => {
        this.pythonMessageRef.current.show(); // show the modal
    };

    render() {
        return (
            <>

                <div
                    className="listHeader"
                >
                    <Row className="listInputRow">

                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    allowClear={true}
                                    onChange={(value) => this.handleChange(value)}
                                    style={{ width: 150 }}
                                    status={this.state.Notcompany ? "error" : false}
                                />


                                <Checkbox
                                    checked={this.state.selectAllDrivers}
                                    onChange={async (e) => {
                                        await this.setState({
                                            selectAllDrivers: e.target.checked,
                                        });
                                        if (this.state.selectAllDrivers) {
                                            await this.setState({
                                                Notdriver: false,
                                            });
                                        }

                                        await this.handleSelectAllDrivers();
                                    }}
                                />
                                {this.context.translate("_ALL_")}

                                <Select
                                    className="searchInput"
                                    mode="multiple"
                                    value={this.state.selectedDriver}
                                    maxTagCount="responsive"
                                    onChange={(val) => {
                                        this.setState({
                                            selectedDriver: val,
                                            Notdriver: false,
                                        });
                                        if (
                                            this.driverLoginReportStore?.getDrivers.length >
                                            val.length
                                        ) {
                                            this.setState({ selectAllDrivers: false });
                                        } else {
                                            this.setState({ selectAllDrivers: true });
                                        }
                                    }}
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
                                    )}
                                    optionFilterProp="children"
                                    style={{ width: 150 }}

                                    status={this.state.Notdriver ? "error" : false}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.driverLoginReportStore?.getDrivers?.map((val) => {
                                        return <Option value={val.driverId}>{val.name}</Option>;
                                    })}
                                </Select>




                                <RangePicker
                                    placeholder={["From Date", "To Date"]}
                                    format="DD-MM-YYYY"
                                    style={{ width: 350, borderRadius: "25px" }}
                                    onChange={(dates) => {
                                        this.onDateTimeChange(dates);
                                    }}
                                    // disabledDate={(current) =>
                                    //     current && current > dayjs().endOf("day")
                                    // }
                                    defaultValue={[
                                        dayjs().startOf("day"),
                                        dayjs().startOf("day")
                                    ]}
                                />


                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();

                                    }}
                                >
                                    {" "}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                            </Space>

                        </Col>

                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={4}
                        >
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            // marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Button
                                    className="downloadExcelButton"
                                    disabled={
                                        this.driverExpenseReportStore?.expenseReport?.length > 0 ? false : true
                                    }
                                >
                                    <Dropdown
                                        overlayClassName="export-dropdown"
                                        menu={this.ExportMenuProps}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                marginInlineEnd: "30px",
                                            }}
                                            src={downloadIcon}
                                        ></Image>
                                    </Dropdown>
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>

                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.driverExpenseReportStore?.total}
                        columns={this.state.column}
                        dataSource={this.driverExpenseReportStore?.expenseReport}

                        loading={this.driverExpenseReportStore?.loading}
                        onChange={this.handleTableChange}
                    />

                    <Modal
                        open={this.state.showMonthPopup}
                        title={
                            <div>
                                {" "}
                                <i
                                    style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                                    class="bi bi-exclamation-triangle"
                                ></i>{" "}
                                {this.context.translate("_FLEET_ALERT_")}
                            </div>
                        }
                        onOk={() => this.setState({ showMonthPopup: false })}
                        onCancel={() => this.setState({ showMonthPopup: false })}
                        footer={false}
                    >
                        {/* For Reports prior to 6 months please contact administrator */}
                        {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
                    </Modal>

                    <PythonMessageAlert
                        ref={this.pythonMessageRef}
                        message={this.state.reportmessage}
                    />
                </div>
            </>
        );
    }
}
DriverExpenseReport.contextType = StoreContext;
export default observer(withRouter(DriverExpenseReport));
